import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Which profile a dual-role user (Admin and Learner) last chose, so the toggle
 * holds on shared routes and across a refresh (redux-persist keeps it).
 * `''` means no choice recorded yet.
 */
export type RoleMode = 'admin' | 'user' | '';

const initialState: { data: RoleMode } = { data: '' };

const roleModeSlice = createSlice({
  name: 'roleMode',
  initialState,
  reducers: {
    setRoleMode: (state, action: PayloadAction<RoleMode>) => {
      state.data = action.payload;
    }
  }
});

export default roleModeSlice.reducer;
export const { setRoleMode } = roleModeSlice.actions;
